/* Prepared MIYAKO translations; never calls a third-party translation service. */
(() => {
  'use strict';
  const configNode = document.getElementById('mm-site-language');
  if (!configNode || window.MiyakoSiteTranslation) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
  const normalize = value => value.replace(/\s+/gu, ' ').trim();
  const ignored = 'script,style,noscript,svg,code,pre,textarea,[translate="no"],[data-mm-no-translate],.shopify-preview-bar';
  const state = { locale: config.locale, ready: false };
  window.MiyakoSiteTranslation = state;
  fetch(config.dictionary, { credentials: 'omit', cache: 'default' })
    .then(response => { if (!response.ok) throw new Error('dictionary unavailable'); return response.json(); })
    .then(dictionary => {
      if (dictionary.locale !== config.locale) return;
      const text = dictionary.text;
      const own = (object, key) => Object.prototype.hasOwnProperty.call(object, key);
      const original = new WeakMap();
      const patterns = Object.entries(dictionary.templates || {}).map(([source, target]) => ({
        regex: new RegExp('^' + source.split('{count}').map(part => part.replace(/[.*+?^${}()|[\]\\]/gu, '\\$&')).join('(\\d+)') + '$', 'u'), target
      }));
      const translate = (value, depth = 0) => {
        const key = normalize(value);
        if (!key) return value;
        let replacement = own(text, key) ? text[key] : null;
        if (replacement === null) {
          for (const pattern of patterns) {
            const match = key.match(pattern.regex);
            if (match) { replacement = pattern.target.replace('{count}', match[1]); break; }
          }
          // Structured specifications retain every numeric value and product code.
          const spec = key.match(/^([^:]+):\s*(.*)$/u);
          if (spec && own(dictionary.labels, spec[1])) {
            const detail = own(dictionary.values, spec[2]) ? dictionary.values[spec[2]] : spec[2];
            replacement = dictionary.labels[spec[1]] + ': ' + detail;
          }
          const photo = key.match(/^(View photo|Photo) (\d+)$/u);
          if (photo && own(dictionary.labels, photo[1])) replacement = dictionary.labels[photo[1]] + ' ' + photo[2];
          if (replacement === null && depth < 3) {
            const arrow = key.match(/^(.*?)(\s*[↗→])$/u);
            if (arrow) {
              const base = translate(arrow[1], depth + 1);
              if (base !== arrow[1]) replacement = base + arrow[2];
            }
            if (replacement === null && key.includes(' · ')) {
              const parts = key.split(' · ').map(part => translate(part, depth + 1));
              if (parts.join(' · ') !== key) replacement = parts.join(' · ');
            }
            const currency = key.match(/^(JPY\s+)(each|per set)$/u);
            if (replacement === null && currency && own(text, currency[2])) replacement = currency[1] + text[currency[2]];
            const prefix = key.match(/^(View recommended|View)\s+(.+)$/u);
            if (replacement === null && prefix && own(text, prefix[1])) replacement = text[prefix[1]] + ' ' + translate(prefix[2], depth + 1);
            const breadcrumb = key.match(/^(\/\s*)(.+)$/u);
            if (replacement === null && breadcrumb && own(text, breadcrumb[2])) replacement = breadcrumb[1] + text[breadcrumb[2]];
            const harvest = key.match(/^(.*?)(\(First (?:Harvest|Flush)\))$/u);
            if (replacement === null && harvest) {
              const label = harvest[2].slice(1, -1);
              if (own(text, label)) replacement = harvest[1] + '(' + text[label] + ')';
            }
            if (replacement === null && key.length < 220 && /matcha|tin|sample/iu.test(key)) {
              let name = key;
              for (const [source, target] of Object.entries(dictionary.product_terms || {})) name = name.split(source).join(target);
              if (name !== key) replacement = name;
            }
          }
        }
        if (replacement === null || replacement === key) return value;
        return value.match(/^\s*/u)[0] + replacement + value.match(/\s*$/u)[0];
      };
      const updateText = node => {
        const parent = node.parentElement;
        if (!parent || parent.closest(ignored) || parent.isContentEditable) return;
        const current = node.nodeValue;
        const saved = original.get(node);
        if (saved && current === saved.output) return;
        const output = translate(current);
        original.set(node, { input: current, output });
        if (output !== current) node.nodeValue = output;
      };
      const attributes = ['placeholder', 'aria-label', 'title', 'alt'];
      const updateAttributes = element => {
        if (element.closest(ignored) || element.isContentEditable) return;
        for (const attribute of attributes) {
          if (!element.hasAttribute(attribute)) continue;
          const value = element.getAttribute(attribute);
          const translated = translate(value);
          if (translated !== value) element.setAttribute(attribute, translated);
        }
      };
      const scan = root => {
        if (root.nodeType === Node.TEXT_NODE) { updateText(root); return; }
        if (root.nodeType !== Node.ELEMENT_NODE || root.closest(ignored)) return;
        updateAttributes(root);
        const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
        let node;
        while ((node = walker.nextNode())) updateText(node);
        for (const element of root.querySelectorAll('[placeholder],[aria-label],[title],[alt]')) updateAttributes(element);
      };
      scan(document.body);
      const pending = new Set();
      let scheduled = false;
      const flush = () => {
        scheduled = false;
        const roots = [...pending]; pending.clear();
        for (const root of roots) if (root.isConnected) scan(root);
      };
      const observer = new MutationObserver(records => {
        for (const record of records) {
          if (record.type === 'characterData') pending.add(record.target);
          else if (record.type === 'attributes') pending.add(record.target);
          else for (const node of record.addedNodes) pending.add(node);
        }
        if (pending.size && !scheduled) { scheduled = true; requestAnimationFrame(flush); }
      });
      observer.observe(document.body, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: attributes });
      // Preserve the chosen language when custom HTML contains root-relative storefront links.
      document.addEventListener('click', event => {
        const link = event.target.closest && event.target.closest('a[href]');
        if (!link || link.hasAttribute('download')) return;
        const raw = link.getAttribute('href');
        if (!raw || raw.startsWith('#') || !/^(?:https?:|\/)/u.test(raw)) return;
        let url; try { url = new URL(raw, location.href); } catch (_) { return; }
        if (url.origin !== location.origin || !/^\/(?:products|collections|pages|policies|blogs|cart)(?:\/|$)/u.test(url.pathname)) return;
        const root = window.Shopify && Shopify.routes && Shopify.routes.root;
        if (root && root !== '/' && !url.pathname.startsWith(root)) {
          url.pathname = root.replace(/\/$/u, '') + url.pathname;
          link.href = url.href;
        }
      }, true);
      state.ready = true;
      document.dispatchEvent(new CustomEvent('miyako:translations-ready', { detail: { locale: config.locale } }));
    })
    .catch(() => { state.ready = false; });
})();
